import React from 'react';

import { AssessmentIcon } from 'pages/Landings/components/Icons';
import Paragraph from 'pages/Landings/components/Paragraph';
import TopicContent from 'pages/Landings/components/TopicContent';
import TopicHeading from 'pages/Landings/components/TopicHeading';
import TopicTemplate from 'pages/Landings/components/TopicTemplate';

const Assessment: React.FC = () => {
    return (
        <TopicTemplate
            heading={
                <TopicHeading
                    title="Assessment"
                    description="Instantly turn software inventories or host data into vulnerability reports. Make vulnerability assessment a seamless feature in your product."
                    illustration={<AssessmentIcon />}
                />
            }
            content={
                <TopicContent link="https://docs.vulners.com/docs/products/assessment/">
                    <Paragraph
                        primary="Built in, not bolted on"
                        secondary="Instead of standing up yet another scanner, embed assessment where your data already lives. Pass inventories from your CMDB or XDR and the Audit API deterministically maps them to the right CVEs - no guesswork, no extra infrastructure."
                    />
                    <Paragraph
                        primary="Built for Speed and CI/CD"
                        secondary="It’s fast enough for scale and CI/CD. Typical responses land around ~0.1s per component, so you can assess large estates, containers, or builds nearly in real time. Use it at pre-release gates to block risky builds, annotate asset lists, and surface fixes automatically - assessment at API speed, not scan-window speed."
                    />
                    <Paragraph
                        primary="Embedded Workflow, Zero Friction"
                        secondary="Embed a “Scan for vulnerabilities” button in your product and return actionable JSON or branded reports while Vulners maintains the vulnerability definitions and matching logic. Because it works with the assets you already track, it drops cleanly into DevSecOps workflows without network probes or credentials. Move from assessment as an event to continuous assessment with instant, accurate findings your users can act on."
                    />
                </TopicContent>
            }
        />
    );
};

export default Assessment;
